(function () {
  if (!window.AlbRabattVorschau) {
    window.AlbRabattVorschau = (function () {
      var TOKEN = ((window.__albSf || {}).token || 'd217975e07f1cd5d72cd21f80c7a58ab');
      var API = 'https://' + ((window.__albSf || {}).domain || location.hostname) + '/api/2024-10/graphql.json';
      var CACHE_KEY = 'alb_rv_v2', CACHE_TTL = 10 * 60 * 1000, CHUNK = 100;
      var Q = 'mutation cartCreate($input: CartInput!) {'
        + ' cartCreate(input: $input) {'
        + '   cart {'
        + '     cost { subtotalAmount { amount } totalAmount { amount } }'
        + '     discountAllocations { discountedAmount { amount } ... on CartAutomaticDiscountAllocation { title } ... on CartCodeDiscountAllocation { code } ... on CartCustomDiscountAllocation { title } }'
        + '     lines(first: ' + CHUNK + ') { nodes {'
        + '       cost { subtotalAmount { amount } totalAmount { amount } }'
        + '       merchandise { ... on ProductVariant { id } }'
        + '       discountAllocations { discountedAmount { amount } ... on CartAutomaticDiscountAllocation { title } ... on CartCodeDiscountAllocation { code } ... on CartCustomDiscountAllocation { title } }'
        + '     } }'
        + '   }'
        + '   userErrors { field message }'
        + ' }'
        + '}';
      var pending = [], timer = null, codesPromise = null;

      /* Karte rendert den Normalpreis serverseitig mit | money_with_currency ("79,90 EUR") –
         das JS formatiert identisch (Shop-Format "{{amount_with_comma_separator}} EUR"). */
      var CUR = ((window.__albSf || {}).currency || 'EUR');
      function fmt(a) { return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a) + ' ' + CUR; }
      function r2(a) { return Math.round(a * 100) / 100; }

      function getActiveCodes() {
        if (codesPromise) return codesPromise;
        codesPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var all = cart.discount_codes || [];
            var items = cart.items || [];
            if (items.length > 0) {
              var applied = {};
              items.forEach(function (it) { (it.discounts || []).forEach(function (d) { if (d.title) applied[String(d.title).toLowerCase()] = 1; }); });
              return all.filter(function (d) { /* Code im Warenkorb klein/groß beliebig (z. B. „thumann“ vs. Titel „THUMANN“) */ return d.applicable === true || applied[String(d.code).toLowerCase()]; }).map(function (d) { return d.code; });
            }
            return all.map(function (d) { return d.code; });
          })
          .catch(function () { return []; });
        return codesPromise;
      }

      function readCache(key) {
        try {
          var raw = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
          if (raw && raw.t && Date.now() - raw.t < CACHE_TTL && raw.k === key) return raw.v || {};
        } catch (e) {}
        return {};
      }
      function writeCache(key, val) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), k: key, v: val })); } catch (e) {}
      }

      /* Ein Wegwerf-Warenkorb → Map variantId → { orig, disc, now, pct, label } */
      function cartCreate(ids, code) {
        var input = { lines: ids.map(function (id) { return { quantity: 1, merchandiseId: 'gid://shopify/ProductVariant/' + id }; }) };
        if (code) input.discountCodes = [code];
        return fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
          body: JSON.stringify({ query: Q, variables: { input: input } })
        })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var cc = j && j.data && j.data.cartCreate;
          if (!cc || !cc.cart || (cc.userErrors && cc.userErrors.length)) return null;
          var cart = cc.cart;
          var cartAlloc = cart.discountAllocations || [];
          var cartLevel = cartAlloc.reduce(function (s, d) { return s + parseFloat(d.discountedAmount.amount); }, 0);
          var cartSub = parseFloat(cart.cost.subtotalAmount.amount) || 0; /* bereits nach Zeilen-Rabatten */
          var ratio = (cartSub > 0 && cartLevel > 0) ? cartLevel / cartSub : 0;
          var cartLabel = cartAlloc.length ? (cartAlloc[0].title || cartAlloc[0].code || '') : '';
          var out = {};
          (cart.lines && cart.lines.nodes || []).forEach(function (li) {
            var id = String(li.merchandise && li.merchandise.id || '').split('/').pop();
            if (!id) return;
            var orig = parseFloat(li.cost.subtotalAmount.amount) || 0;
            var lineAlloc = li.discountAllocations || [];
            var lineLevel = lineAlloc.reduce(function (s, d) { return s + parseFloat(d.discountedAmount.amount); }, 0);
            var afterLine = parseFloat(li.cost.totalAmount.amount);
            if (isNaN(afterLine)) afterLine = orig - lineLevel;
            var disc = r2(lineLevel + afterLine * ratio);
            if (orig <= 0 || disc <= 0) { out[id] = null; return; }
            var label = lineAlloc.length ? (lineAlloc[0].title || lineAlloc[0].code || '') : cartLabel;
            out[id] = { orig: orig, disc: disc, now: r2(orig - disc), pct: Math.round(disc / orig * 100), label: label || (code || '') };
          });
          return out;
        })
        .catch(function () { return null; });
      }

      function resolve(ids) {
        return getActiveCodes().then(function (codes) {
          var key = codes.slice().sort().join(',');
          var cached = readCache(key);
          var missing = ids.filter(function (id) { return !(id in cached); });
          if (!missing.length) return cached;
          var runs = [];
          for (var i = 0; i < missing.length; i += CHUNK) {
            var chunk = missing.slice(i, i + CHUNK);
            /* Immer auch ein Lauf nur mit automatischen Rabatten: im Sammel-Warenkorb aller Karten
               kann ein nicht kombinierbarer Code (z. B. 5 % Affiliate) Shopify dazu bringen, den
               Code statt der Automatik (z. B. Camping-Bundle 10 %) zu nehmen, obwohl beim Kauf des
               einzelnen Produkts die Automatik greift. Je Karte zählt der höchste Rabatt. */
            runs.push(cartCreate(chunk, null));
            codes.forEach(function (c) { runs.push(cartCreate(chunk, c)); });
          }
          return Promise.all(runs).then(function (results) {
            var best = {};
            results.forEach(function (res) {
              if (!res) return;
              Object.keys(res).forEach(function (id) {
                var r = res[id];
                if (r && (!best[id] || r.disc > best[id].disc)) best[id] = r;
              });
            });
            missing.forEach(function (id) { cached[id] = best[id] || null; });
            writeCache(key, cached);
            return cached;
          });
        });
      }

      function render(card, r) {
        var now = card.querySelector('[data-pg-now]');
        var was = card.querySelector('[data-pg-was]');
        var badge = card.querySelector('[data-pg-disc]');
        if (!now || !r || !(r.pct > 0)) return;
        now.textContent = fmt(r.now);
        if (was) { was.textContent = fmt(r.orig); was.hidden = false; }
        if (badge) { badge.textContent = '-' + r.pct + '\u00a0%'; badge.title = r.label || ''; badge.hidden = false; }
        card.setAttribute('data-has-disc', '1');
      }

      function flush() {
        timer = null;
        var byVariant = {}, ids = [];
        pending.splice(0).forEach(function (sec) {
          var cards = sec.querySelectorAll('.alb-pg-card[data-pg-variant]');
          for (var i = 0; i < cards.length; i++) {
            var c = cards[i];
            if (c.hasAttribute('data-pg-disc-done')) continue;
            c.setAttribute('data-pg-disc-done', '1');
            var id = c.getAttribute('data-pg-variant');
            if (!/^\d+$/.test(id)) continue;
            if (!byVariant[id]) { byVariant[id] = []; ids.push(id); }
            byVariant[id].push(c);
          }
        });
        if (!ids.length) return;
        resolve(ids).then(function (map) {
          ids.forEach(function (id) { if (map[id]) byVariant[id].forEach(function (c) { render(c, map[id]); }); });
        });
      }

      function register(sectionEl) {
        if (!sectionEl) return;
        pending.push(sectionEl);
        clearTimeout(timer);
        timer = setTimeout(flush, 40);
      }

      /* Theme-Editor: neu gerenderte Section erneut anmelden */
      document.addEventListener('shopify:section:load', function (e) { if (e.target) register(e.target); });

      return { register: register };
    })();
  }
  /* Ausgelagert (2026-09-17): alle Grid-Sections mit aktiver Vorschau anmelden (Attribut kommt aus dem Section-Root) */
  document.querySelectorAll('[data-alb-rabatt-vorschau]').forEach(function (el) {
    if (el.hasAttribute('data-alb-rv-registered')) return;
    el.setAttribute('data-alb-rv-registered', '1');
    window.AlbRabattVorschau.register(el);
  });
})();
